import React from 'react'
import DataGrid from '../../../../table/DataGrid';

const Table = ({ columns, rowsPerPage, skip, loading, totalList, list }) => {
  return (
    <DataGrid
      id='classes'
      nameModule='class'
      rows={list}
      loading={loading}
      totalRows={totalList}
      skip={skip}
      rowsPerPage={rowsPerPage}
      columns={columns}
      labelNoRows="You don't have any classes yet"
    />
  )
}

export default Table